import styles from "../PoochBeach/PoochBeach.module.css";
import { altImages } from "../../pages/HomePageMain";
import stylesLast from "./LastHomepageSection.module.css";

const LastHomepageSection: React.FC = () => {
  return (
    <>
      <div className={styles.poochBeachContainer}>
        <div className={styles.textSection}>
          <div className={styles.textContainer}>
            <div className={styles.rightTitle}>Hidden Gem</div>
            <div className={styles.rightText}>
              We are so happy you have found our little hidden gem in Navarre
              Florida. She is truly a unique camping experience that we know
              you'll love. We can't wait to have you camp with us and become
              apart of our Hideaway Family! See you soon.
            </div>
          </div>
        </div>
        <div className={styles.imageWrapper}>
          <img
            src={
              "https://thehideawayretreat-storage-images234800-staging.s3.amazonaws.com/DF2496BA-8143-4930-BCB1-4666C36455F7.jpeg"
            }
            alt={altImages}
            className={stylesLast.image}
            loading="eager"
            draggable={false}
            decoding="async"
          />
        </div>
      </div>
    </>
  );
};

export default LastHomepageSection;
